import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      name: "books",
      path: "/",
      component: () => import("@/views/Books"),
      meta: { title: "Bücher" }
    },
    {
      name: "about",
      path: `/%C3%BCber-mich`,
      component: () => import("@/views/About"),
      meta: { title: "Über mich" }
    },
    {
      name: "grief",
      path: "/trauer",
      component: () => import("@/views/Grief"),
      meta: { title: "Trauer" }
    },
    {
      name: "trauma",
      path: "/trauma",
      component: () => import("@/views/Trauma"),
      meta: { title: "Trauma" }
    },
    {
      name: "english",
      path: "/english",
      component: () => import("@/views/English"),
      meta: { title: "English" }
    },
    {
      name: "legal",
      path: "/impressum",
      component: () => import("@/views/Legal"),
      meta: { title: "Impressum" }
    },
    {
      name: "privacy",
      path: "/datenschutz",
      component: () => import("@/views/Privacy"),
      meta: { title: "Datenschutz" }
    },
    { path: "*", component: () => import("@/views/404") }
  ]
});
